<script setup lang="ts">
import Playground from "@/components/FormulaPlayground/Playground.vue"
import { usePlaygroundStore } from "@/stores"
import { DialogSize, KDialog } from "@kaleidoscope-solutions/ks-design-system"

const playgroundStore = usePlaygroundStore()
</script>

<template>
  <KDialog
    :open="true"
    :size="DialogSize.fullsize"
    :esc="false"
    @close="playgroundStore.dialog = false"
  >
    <template #default>
      <Playground />
    </template>
  </KDialog>
</template>
